import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { useMembership } from '../../../contexts/MembershipServiceContext';

import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

const Footer = () => {
	const { t } = useTranslation('footer');
	const { membershipListData } = useMembership();
	const { result } = useSelector(
		(state) => state.customerDetailsSlice.postBrowserDetails
	);

	const currentYear = new Date().getFullYear();

	return (
		<Box
			component='footer'
			sx={{
				px: 2,
				py: 3,
				mt: 2
			}}
		>
			<Stack direction='column' alignItems='flex-start' spacing={1}>
				<Box
					component='img'
					src={membershipListData?.logo}
					alt={membershipListData?.name}
					sx={{
						height: 45,
						objectFit: 'contain'
					}}
				/>

				<Typography variant='caption' sx={{ color: 'text.secondary' }}>
					{t('copyright', { year: currentYear })}
				</Typography>

				<Stack direction='row' spacing={1} alignItems='center'>
					<Link
						href={result.landing_page_link || '/'}
						sx={{
							color: 'text.secondary',
							fontSize: '0.75rem',
							textDecoration: 'underline'
						}}
					>
						{t('home')}
					</Link>
					<Typography variant='caption' sx={{ color: 'text.secondary' }}>
						|
					</Typography>
					<Link
						href={result.terms_and_conditions_link}
						target='_blank'
						rel='noreferrer'
						sx={{
							color: 'text.secondary',
							fontSize: '0.75rem',
							textDecoration: 'underline'
						}}
					>
						{t('termsAndConditions')}
					</Link>
					<Typography variant='caption' sx={{ color: 'text.secondary' }}>
						|
					</Typography>
					<Link
						href={result.privacy_policy_link}
						target='_blank'
						rel='noreferrer'
						sx={{
							color: 'text.secondary',
							fontSize: '0.75rem',
							textDecoration: 'underline'
						}}
					>
						{t('privacyPolicy')}
					</Link>
				</Stack>
			</Stack>
		</Box>
	);
};

export default Footer;
